/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfBilling } from '../../models/data-page-of-billing';

export interface BillingGetBillingList$Params {
  emrpracticeId?: string | null;
  PatientId?: string | null;
  pageNumber?: number;
}

export function billingGetBillingList(http: HttpClient, rootUrl: string, params?: BillingGetBillingList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfBilling>> {
  const rb = new RequestBuilder(rootUrl, billingGetBillingList.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('PatientId', params.PatientId, {});
    rb.query('pageNumber', params.pageNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfBilling>;
    })
  );
}

billingGetBillingList.PATH = '/billing/list';
